<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Tickets & Sponsorships">
            <div>
              <AmountSelectorListTeachBreakfast />
              <ErrorLabel field="amount" />
            </div>
            <p class="note">
              * All sponsors $3,600 or more receive a reserved table at the breakfast (10 tickets). Donors of $1,800 or more will be listed in <a
                href="https://teachcoalition.org/leadershipcircle/"
                style="color: #06346b"
                target="_blank"
                >Teach NYS’s Leadership Circle</a
              >. Donors of $5,000 or more will be listed in the
              <a
                href="https://www.ou.org/benefactor/"
                target="_blank"
                style="color: #06346b"
                >OU Benefactor Circle</a
              >. All contributors and sponsors will be listed on breakfast materials.
            </p>
          </FormSection>
          <FormSection title="Payment Options">
            <div class="frequency">
              <PaymentOptions addSplit :splitMonths="8" />
            </div>
          </FormSection>

          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://teachcoalition.org/privacy-policy/"/>
                  </FormRow>               
          </FormSection>

          <FormSection title="Guests Information" v-if="getValue('custom.ticketsQnt') > 0">

            <FormRow inline>
              <FormCol field="custom.guests" width="twothird" :showLabel="false">
                <FormLabel class="control-label"> Additional Guests: </FormLabel>
                <FormSelect>
                  <option value="Yes, I am bringing guests and I have their information">Yes, I am bringing guests and I have their information</option>
                  <option value="Yes, I am bringing guests but I do not have their information currently">Yes, I am bringing guests but I do not have their information currently</option>
                  <option value="No, I am not bringing guests">No, I am not bringing guests</option>

            </FormSelect>          

            </FormCol>
            <ErrorLabel field="custom.guests"/>
            </FormRow>

            <div v-if="getValue('custom.guests') == 'Yes, I am bringing guests and I have their information'">
              <div v-for="guest in guestQty" :key="`guest${guest}`">
                <h4 style="padding-bottom: 8px;padding-top: 8px;">Guest #{{ guest }}</h4>
                <FormRow inline>
              <FormCol :field="`custom.guestsName${guest}`" width="full" :showLabel="false">
                <FormLabel class="control-label"> Name </FormLabel>
                <FormInput type="text" class="width-full" :field="`custom.guestsName${guest}`"/>
              </FormCol>
              <FormCol :field="`custom.guestsEmail${guest}`"  width="full" :showLabel="false">
                <FormLabel class="control-label"> Email </FormLabel>
                <FormInput type="text" class="width-full" :field="`custom.guestsEmail${guest}`"  />
              </FormCol>
            </FormRow>
              </div>
          </div>
          <div v-else-if="getValue('custom.guests') == 'Yes, I am bringing guests but I do not have their information currently'">
            <p class="teach__conatc">Teach NYS with follow up with you to collect your guest information</p>
          </div>
          <div v-else></div>
          <FormRow inline>
              <FormCol field="custom.schoolName" width="half" :showLabel="false">
                <FormLabel class="control-label"> School Affiliation: </FormLabel>
                <FormInput
              type="text"
              class="width-full"
              field="custom.schoolName"
                />
              </FormCol>
            </FormRow>   
            <ErrorLabel field="custom.schoolName" />             
          </FormSection>
          <FormSection title="Address">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow>
                <PaymentType check_text="Pay by Check/DAF" />
              </FormRow>          
            <FormRow inline>
              <FormCol
                  class="doublepay"
                  field="card"
                  :showLabel="false"
                  check_text=""
                />
            </FormRow>
            <FormRow
                v-if="form.gateway === 'check'"
                style="justify-content: center"
                class="checktext"
              >
                <div>
                  Please mail your check to the following address:
                  <p style="text-align: center">
                    <strong
                      >Teach Coalition<br />
                      C/O Caleb Fischer<br />
                      40 Rector St, 4th Floor<br />
                      New York, NY 10006</strong
                    >
                  </p>
                </div>
              </FormRow>            
          </FormSection>
          <PaymentButton showAmount btnText="Pay now" />
          <p class="note">
            <br />All donations are tax-deductible to the full extent permitted by law.
          </p>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { usePaymentForm } from "~/shared/use-payment-form";

import { computed, defineComponent, onMounted, type PropType, ref, watch } from "vue";

import { queryParams } from "~/shared/query-params";

export default defineComponent({
  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { getValue, setValue, form, submit } = usePaymentForm();

    var guestQty = ref(0);



    if (props.subCampaign) {
      setValue("applications.0.subCampaign", props.subCampaign);
    }

    if (props.campaign) {
      setValue("applications.0.campaign", props.campaign);
    }

    
    watch(
      () => getValue("amount"),
      (val) => {
        if (val && Number(getValue("amount")) < 100) {
          setValue("custom.guests", 'No, I am not bringing guests');
        } else{
          setValue("custom.guests", 'Yes, I am bringing guests and I have their information');
        }
      }
    );



    watch(
      () => getValue("custom.ticketsQnt"),
      (val) => {
        if (val) {
          guestQty.value = Number(getValue("custom.ticketsQnt"));
        }
      }
    );


    // watch(guestQty {

    //   if (getValue("custom.ticketsQnt") > 0) {
    //     guestQty.value = getValue("custom.ticketsQnt");
    //   }
    // });



    onMounted(() => {
      const params = queryParams();

      if (params.utm_content) {
        if (
          !["Direct Mail", "Telemarketing", "Text SMS Message"].includes(
            params.utm_content
          )
        ) {
          throw new Error("Invalid subcampaign");
        }

        setValue("applications.0.subCampaign", params.utm_content);
      }
    });

    return {
      form,
      getValue,
      submit,
      guestQty
    };
  },
});
</script>
<style scoped lang="scss">
.form-container.ou-donation-form {
  margin: 0px;
  padding: 0px;
  box-shadow: none;
  max-width: 100%;
}
h2 {
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 0px;
  font-size: 20px;
  color: black;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.note {
  font-style: italic;
  line-height: 1.4;
  font-weight: bold;
  font-size: 14px;

  a {
    text-decoration: none;
  }
}
::v-deep .amount-row {
  min-width: 31.3333% !important;
  max-width: 31.3333% !important;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  label {
    font-weight: 500;
    background: #016d9a !important;
    color: white !important;
    display: block !important;
  }
  input[type="radio"]:checked + label {
    background: #be9e5f !important;
  }
  .label-description {
    background: none !important;
    display: block !important;
    text-align: center !important;
    font-size: 17px;
    font-style: italic;
    padding-top: 0;
    color: white !important;
  }
  .label-amount {
    background: none !important;
    display: block !important;
    height: auto !important;
    max-width: 100%;
    min-width: 100% !important;
    border: none !important;
    font-size: 18px;
    text-align: center;
  }
  .amount_other__wrapper::before {
    background: #016d9a !important;
    color: white !important;
    font-weight: bold;
  }
}

.checktext {
  margin-top: -20px;
  line-height: 21px;
  p {
    margin-top: 5px;
  }
}
::v-deep span.flex > span {
    display: flex;
}

.teach__conatc{
  display: inline-block;
  padding: 5px 11px;
  margin-bottom: 15px;
  font-weight: 600;
  color: #3d3e40;
  font-size: 13px;
  font-style: italic;
  background: #f8f8f8;
}
</style>
